// third-party
import { combineReducers } from 'redux';

// project import
import menu from './menu';
import userslice from '../../Slices/userslice';
import planslice from '../../Slices/planslice';
import adminslice from '../../Slices/AdminSlice';
import templateslice from '../../Slices/templateslice';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({ menu, userslice, planslice, templateslice,adminslice, });

export default reducers;
